module.exports = __webpack_public_path__ + "static/media/cover-drones.83b18b07.jpg";